/**
 * Custom HTML element → React component registry for RichText.
 *
 * Each custom element (e.g. <file-card>, <section-cta>) is mapped to its
 * shared component + property parser. To add a new element:
 * 1. Create component directory in richTextComponents/
 * 2. Export Component, parseProps from index.ts
 * 3. Add one line here
 */
import { FileCard, parseFileCardProps } from "./fileCard";
import { CustomButton, parseCustomButtonProps } from "./customButton";
import { SectionCta, parseSectionCtaProps } from "./sectionCta";
import { MediaBlock, parseMediaBlockProps } from "./mediaBlock";
import { Checklist, parseChecklistProps } from "./checklist";

export const sharedCustomElements = {
  "file-card": ({ node }) => <FileCard attrs={parseFileCardProps(node.properties)} />,
  "custom-button": ({ node }) => <CustomButton attrs={parseCustomButtonProps(node.properties)} />,
  "section-cta": ({ node }) => <SectionCta attrs={parseSectionCtaProps(node.properties)} />,
  "media-block": ({ node }) => <MediaBlock attrs={parseMediaBlockProps(node.properties)} />,
  checklist: ({ node }) => <Checklist attrs={parseChecklistProps(node.properties)} />,
};
